<template>
  <button
    type="button"
    :class="
      isDisclaimer ? 'mdn-Footer-disclaimer-librasLink' : 'mdn-Menu-top-event'
    "
    title="Assistente de Libras"
    @click.prevent="toggleLibras()"
  >
    <span class="mdn-Icon-libras mdn-Icon--sm" aria-hidden="true"></span>
  </button>
</template>
<script lang="ts">
import Vue from "vue";

import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "LibrasButton",
})
export default class LibrasButton extends Vue {
  showLibras = false;
  @Prop({ default: false }) readonly isDisclaimer!: boolean;

  toggleLibras(): void {
    const win = window as any;
    this.showLibras = !this.showLibras;

    if (win.ht) {
      const handTalk = document.getElementsByClassName("ht-skip") as any;
      const handTalkBTN = handTalk[0].getElementsByTagName("button") as any;
      const event = new MouseEvent(
        this.showLibras ? "mouseenter" : "mouseleave",
        {
          view: window,
          bubbles: true,
          cancelable: true,
        }
      );
      handTalkBTN[0].dispatchEvent(event);
    }

    if (this.showLibras) {
      setTimeout(() => {
        this.toggleLibras();
      }, 2000);
    }
  }
}
</script>

<style lang="scss" scoped></style>
